<template>
  <div>
    <!-- <WsDataTablePagenateTypeB
      @pageto="$_onPageto($event)"
      :currentPage="currentPage"
      :dataTotalCount="dataTotalCount"
      :itemsPerPage="itemsPerPage"
      :lastPage="lastPage"
    ></WsDataTablePagenateTypeB> -->
    <!-- v-model="selected" -->
    <VDataTable
      hideDefaultFooter
      :itemKey="itemKey"
      :value="value"
      :items="_items"
      :loading="loading"
      :headers="headers"
      :options="_options"
      :expanded.sync="expanded"
      :showExpand="showExpand"
      :showSelect="isMultiSelect"
      :class="{'row-link':rowClickRead}"
      class="ws-data-table"
      @click:row="$_onRowClick($event)"
      @input="$emit('update:selected',$event)"
      @update:options="$_onOptionsUpdate($event)"
    >
      <template
        v-for="(wrapColumn, wrapColumnIndex) in wrapColumns"
        v-slot:[`item.${wrapColumn}`]="{ item }"
      >
        <div :key="wrapColumnIndex" class="wrap-cell">
          {{ item[wrapColumn] }}
        </div>
      </template>
      <template v-slot:item.dot="{ item }">
        <v-chip
          v-if="item.dot"
          small
          :color="item.dot.color"
        />
      </template>
      <template v-slot:item.name="{ item }">
        <v-chip
          v-for="(chip, chipIndex) in item.chips"
          :key="chipIndex"
          :color="chip.color"
          :textColor="chip.textColor"
          :label="chip.label"
          class="mr-1"
        >
          {{chip.text}}
        </v-chip>
        {{item.name}}
      </template>
      <template v-slot:item.icon="{ item }">
        <v-icon v-if="item.icon !== null"> {{item.icon}} </v-icon>
        <template v-else>-</template>
      </template>
      <template v-slot:footer>
        <WsDataTablePagenateTypeB
          v-if="isPaginationShow"
          @pageto="$_onPageto($event)"
          :dataTotalCount="dataTotalCount"
          :itemsPerPage="itemsPerPage"
          :currentPage="currentPage"
          :lastPage="lastPage"
        ></WsDataTablePagenateTypeB>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <div class="ws-data-table__expand-content">
            <slot name="expanded" :item="item">
              <WsEasyTable
                :fields="displayFields"
                :modelData="$_getModelDataById(item.id)"
              />
            </slot>
          </div>
        </td>
      </template>
      <!-- <template v-slot:item.isActive="{item}">
        <WsLiveStateSwitch
          :value="$_CMS_getValueByFieldKey(field,modelData)"
          :field="field"
          :modelName="parentModelName"
          :modelId="modelId"
          :activeText="$_CMS_getFieldByFieldKey(field,modedFields).activeText"
          :inactiveText="$_CMS_getFieldByFieldKey(field,modedFields).inactiveText"
        ></WsLiveStateSwitch>
      </template> -->
      <template v-slot:item.actions="{ item }">
        <div v-if="isShowBtn">
          <slot name="customBtns" :item="item"/>
          <template v-if="pageMode">
            <WsIconBtn
              v-show="inRowBtnRead"
              tooltip="查看"
              tooltipPosition="top"
              :to="$_getInRowBtnReadUrl(item)"
              class="ml-1 mr-1"
            >mdi-eye</WsIconBtn>
            <WsIconBtn
              v-show="
                inRowBtnUpdate && (
                  item.isInRowBtnUpdateDisabled === undefined ||
                  item.isInRowBtnUpdateDisabled === false
                )
              "
              tooltip="編輯"
              tooltipPosition="top"
              :to="`/${modelName}/${item.id}/update?redirect=${$route.fullPath}`"
              class="ml-1 mr-1"
            >mdi-pencil</WsIconBtn>
          </template>
          <template v-else>
            <WsIconBtn
              v-show="inRowBtnUpdate"
              tooltip="編輯"
              tooltipPosition="top"
              class="ml-1 mr-1"
              :disabled="item.isInRowBtnUpdateDisabled"
              @click.stop="$_onActionUpdateClick(item)"
            >mdi-pencil</WsIconBtn>
            <WsIconBtn
              v-show="inRowBtnRead"
              tooltip="查看"
              tooltipPosition="top"
              @click.stop="$_onActionReadClick(item)"
              class="ml-1 mr-1"
            >mdi-eye</WsIconBtn>
          </template>
          <WsIconBtn
            v-show="
              inRowBtnDelete && (
                item.isInRowBtnDeleteDisabled === undefined ||
                item.isInRowBtnDeleteDisabled === false
              )
            "
            tooltip="刪除"
            tooltipPosition="top"
            class="ml-1 mr-1"
            @click.stop="$_onActionDeleteClick(item)"
          >mdi-delete</WsIconBtn>
          <WsIconBtn
            v-show="inRowBtnComplete"
            tooltip="完成"
            tooltipPosition="top"
            class="ml-1 mr-1"
            @click.stop="$_onActionCompleteClick(item)"
          >mdi-check</WsIconBtn>
        </div>
      </template>

      <template
        v-for="imageItem in _imageItems"
        v-slot:[$_getItemSlotName(imageItem)]="{ item }"
      >
        <v-img
          v-if="item[imageItem]"
          :key="imageItem"
          max-width="100px"
          :src="item[imageItem]"
        />
      </template>
    </VDataTable>

  </div>
</template>

<script>
export default {
  data: () => ({
    expanded: [],
    selected: [],
    itemKey: 'id',
  }),
  methods: {
    $_onOptionsUpdate($event) {
      this.$emit("sort-update", $event);
    },
    $_getModelDataById(id) {
      const modelData = this.items.find((e) => {
        return e.id == id;
      });
      return modelData;
    },
    $_getItemSlotName(item) {
      return "item." + item;
    },
    $_getSpecificItems(type) {
      const items = [];
      for (let displayKey in this.displayFields) {
        const displayField = this.displayFields[displayKey];
        if (displayField.type == type) {
          items.push(displayKey);
        }
      }
      return items;
    },
    $_onPageto(page) {
      this.$emit("pageto", page);
    },
    $_onRowClick(item) {
      if (this.showExpand) {
        const index = this.expanded.indexOf(item);
        if (index === -1) {
          this.expanded.push(item);
        } else {
          this.expanded.splice(index, 1);
        }
      } else if (this.rowClickRead) {
        this.$router.push(this.$_getInRowBtnReadUrl(item));
      } else if (this.rowClickEmit) {
        this.$emit("rowClickInput", item.id);
        this.$emit("row-click-item", item);
      }
    },
    $_onActionReadClick(item) {
      this.$emit("read", item);
    },
    $_onActionUpdateClick(item) {
      this.$emit("update", item);
    },
    $_onActionDeleteClick(item) {
      this.$emit("delete", item);
    },
    $_onActionCompleteClick(item) {
      this.$emit("complete", item);
    },
    $_formatItemVersions(item, itemPre, versionsFields, keyPre = "") {
      for (let versionsFieldKey in versionsFields) {
        const versionsField = versionsFields[versionsFieldKey];
        this.$_formatItem(
          item,
          itemPre.last_version,
          versionsField,
          versionsFieldKey,
          `${keyPre}last_version__`
        );
      }
    },
    $_formatItemPayloads(item, itemPre, payloadsFields, keyPre = "") {
      for (let payloadsFieldKey in payloadsFields) {
        const payloadsField = payloadsFields[payloadsFieldKey];
        this.$_formatItem(
          item,
          itemPre.payload,
          payloadsField,
          payloadsFieldKey,
          `${keyPre}payload__`
        );
      }
    },
    $_formatItemFactorys(item, itemPre, factorysFields, keyPre = "") {
      for (let factorysFieldKey in factorysFields) {
        const factorysField = factorysFields[factorysFieldKey];
        this.$_formatItem(
          item,
          itemPre.factory,
          factorysField,
          factorysFieldKey,
          `${keyPre}factory__`
        );
      }
    },
    $_formatItemAdmins(item, itemPre, adminsFields, keyPre = "") {
      for (let adminsFieldKey in adminsFields) {
        const adminsField = adminsFields[adminsFieldKey];
        this.$_formatItem(
          item,
          itemPre.admin,
          adminsField,
          adminsFieldKey,
          `${keyPre}admin__`
        );
      }
    },
    $_formatItemLocales(item, itemPre, localesFields, keyPre = "") {
      for (let localesFieldKey in localesFields) {
        item[`${keyPre}locales_main__${localesFieldKey}`] = itemPre
          ? itemPre[localesFieldKey]
          : null;
        const locales = this.$store.state.locale.locales;
        locales.forEach((locale) => {
          item[`${keyPre}locales_${locale.code}__${localesFieldKey}`] =
            itemPre && itemPre.locales && itemPre.locales[locale.code]
              ? itemPre.locales[locale.code][localesFieldKey]
              : null;
        });
      }
    },
    $_formatItemBelongsTo(
      item,
      itemPre,
      fieldKey,
      keyPre,
      textKey = "text",
      selectMode = false
    ) {
      if (!itemPre || !itemPre[fieldKey]) {
        return;
      }
      if (selectMode) {
        return;
      }
      let value = "";
      if (this.fields[fieldKey] && this.fields[fieldKey].getText){
          value = this.fields[fieldKey].getText(item[fieldKey])
        }
      item[`${keyPre}${fieldKey}`] = value + 
      (itemPre[fieldKey][textKey]
      ? itemPre[fieldKey][textKey]
      : '');
    },
    $_formatItemHasMany(
      item,
      itemPre,
      fieldKey,
      keyPre = "",
      textKey = "text",
      selectMode = false
    ) {
      if (!itemPre || !itemPre[fieldKey]) {
        return;
      }
      if (selectMode) {
        return;
      }
      let hasManyValue = "";
      itemPre[fieldKey].forEach((hasmanyItem) => {
        if (hasManyValue != "") {
          hasManyValue += ",";
        }
        let value = "";
        if ( this.fields[fieldKey] && this.fields[fieldKey].getText){
          value = this.fields[fieldKey].getText(hasmanyItem)
        }
        if (value){
          hasManyValue += value
        } else {
          hasManyValue += value + hasmanyItem[textKey];
        }
      });
      item[`${keyPre}${fieldKey}`] = hasManyValue;
    },
    $_formatItemDate(item, itemPre, fieldKey, keyPre = "") {
      if (!itemPre || !itemPre[fieldKey]) {
        return;
      }
      item[`${keyPre}${fieldKey}`] = this.$moment(itemPre[fieldKey]).format(
        "YYYY.MM.DD"
      );
    },
    $_formatItemDatetime(item, itemPre, fieldKey, keyPre = "") {
      if (!itemPre || !itemPre[fieldKey]) {
        return;
      }
      item[`${keyPre}${fieldKey}`] = this.$moment(itemPre[fieldKey]).format(
        "YYYY.MM.DD HH:mm:ss"
      );
    },
    $_formatItemCustom(item, itemPre, fieldKey, keyPre = "", getValue) {
      // if (!itemPre || !itemPre[fieldKey]) {
      //   return;
      // }
      item[`${keyPre}${fieldKey}`] = getValue(item);
    },
    $_formatItemSwitch(
      item,
      itemPre,
      fieldKey,
      keyPre = "",
      activeText = "有",
      inactiveText = "無"
    ) {
      if (!itemPre) {
        return;
      }
      item[`${keyPre}${fieldKey}`] = itemPre[fieldKey]
        ? activeText
        : inactiveText;
    },
    $_formatItemSelect(
      item,
      itemPre,
      fieldKey,
      keyPre = "",
      textKey = "text",
      items = []
    ) {
      if (!itemPre || itemPre[fieldKey] == undefined) {
        return;
      }
      const tarItem = items.find((e) => {
        return e.value == item[`${keyPre}${fieldKey}`];
      });
      if (!tarItem) {
        return;
      }
      item[`${keyPre}${fieldKey}`] = tarItem[textKey];
    },
    $_formatItemOther(item, itemPre, fieldKey, keyPre) {
      if (!itemPre) {
        return;
      }
      let value = ""
      if (this.fields[fieldKey] && this.fields[fieldKey].getText && item[fieldKey] !== undefined){
        value = this.fields[fieldKey].getText(item[fieldKey], item)
      } else if (this.fields[fieldKey] && this.fields[fieldKey].getText) {
        value = this.fields[fieldKey].getText(item,fieldKey)
      } else {
        value = itemPre[fieldKey] ? itemPre[fieldKey] : null
      }
      item[`${keyPre}${fieldKey}`] = itemPre ? value : null;
    },
    $_formatItem(item, itemPre, field, fieldKey, keyPre = "") {
      if (field.type == "last_version") {
        this.$_formatItemVersions(item, itemPre, field.fields, keyPre);
      } else if (field.type == "locales") {
        this.$_formatItemLocales(item, itemPre, field.fields, keyPre);
      } else if (field.type == "payload") {
        this.$_formatItemPayloads(item, itemPre, field.fields, keyPre);
      } else if (field.type == "factory") {
        this.$_formatItemFactorys(item, itemPre, field.fields, keyPre);
      } else if (field.type == "admin") {
        this.$_formatItemAdmins(item, itemPre, field.fields, keyPre);
      } else if (field.type == "select") {
        this.$_formatItemSelect(
          item,
          itemPre,
          fieldKey,
          keyPre,
          field.textKey,
          field.items
        );
      } else if (field.type == "switch") {
        this.$_formatItemSwitch(
          item,
          itemPre,
          fieldKey,
          keyPre,
          field.activeText,
          field.inactiveText
        );
      } else if (field.type == "belongsTo") {
        this.$_formatItemBelongsTo(
          item,
          itemPre,
          fieldKey,
          keyPre,
          field.textKey,
          field.selectMode
        );
      } else if (field.type == "hasMany") {
        this.$_formatItemHasMany(
          item,
          itemPre,
          fieldKey,
          keyPre,
          field.textKey,
          field.selectMode
        );
      } else if (field.type == "date") {
        this.$_formatItemDate(item, itemPre, fieldKey, keyPre);
      } else if (field.type == "datetime") {
        this.$_formatItemDatetime(item, itemPre, fieldKey, keyPre);
      } else if (field.type == "custom") {
        this.$_formatItemCustom(
          item,
          itemPre,
          fieldKey,
          keyPre,
          field.getValue
        );
      } else {
        this.$_formatItemOther(item, itemPre, fieldKey, keyPre);
      }
    },
    $_getInRowBtnReadUrl(item) {
      if (this.getCustomReadUrl) return this.getCustomReadUrl(item);
      const basePath = this.tabValue || this.modelName;
      const url = `/${basePath}/${item.id}`;
      const routeQuery = Object.entries(this.$route.query)
        .filter(([_, value]) => _ && value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      const query = item.query ? `${item.query}&${routeQuery}` : `?${routeQuery}`;
      return query ? `${url}${query}` : url;
    }
  },
  computed: {
    _imageItems() {
      return this.$_getSpecificItems("image");
    },
    _items() {
      if(!this.items) return [];
      const _items = JSON.parse(JSON.stringify(this.items));
      _items.forEach((item) => {
        for (let fieldKey in this.fields) {
          // 判斷顯示/隱藏
          const field = this.fields[fieldKey];
          this.$_formatItem(item, item, field, fieldKey);
        }
      });
      return _items;
    },
    _options() {
      return {
        itemsPerPage: this.itemsPerPage,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      };
    }
  },
  props: {
    dataTotalCount: {
      type: Number,
      default: 0,
    },
    sortBy: {
      type: String,
      default: null,
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inRowBtnComplete: {
      type: Boolean,
      default: false,
    },
    rowClickRead: {
      type: Boolean,
      default: false,
    },
    inRowBtnRead: {
      type: Boolean,
      default: true,
    },
    inRowBtnUpdate: {
      type: Boolean,
      default: true,
    },
    inRowBtnDelete: {
      type: Boolean,
      default: true,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    currentPage: [Number, String],
    lastPage: Number,
    modelName: String,
    pageMode: Boolean,
    displayFields: Object,
    fields: Object,
    items: {
      type: Array,
      default: () => [],
    },
    itemsPerPage: Number,
    headers: Array,
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    isShowBtn: {
      type: Boolean,
      default: true,
    },
    rowClickEmit: {
      type: Boolean,
      default: false,
    },
    tabValue:{
      type: String,
      default: null
    },
    isPaginationShow:{
      type: Boolean,
      default: true,
    },
    getCustomReadUrl: {
      type: Function,
    },
    wrapColumns: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    selected: {
      handler() {
        this.itemKey = 'id';
        this.$emit("selected", this.selected);
      },
    },
    value: {
      handler() {
        this.itemKey = 'id';
      },
    },
    items: {
      handler() {
        this.itemKey = 'id';
      },
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-data-table.scss";
@import "../assets/scss/ws-warning-text";
</style>